module.exports = __webpack_public_path__ + "static/media/card-labgif.841e16e5.jpg";